/**
 * 通用方法集合
 */
/**
 * 日期格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 */
function formatDateWithSeperator(datetime, dateSeprator) {
    if (datetime != null) {
        const dateMat = new Date(datetime)
        const year = dateMat.getFullYear()
        const month = dateMat.getMonth() + 1
        const day = dateMat.getDate()
        const timeFormat = year + dateSeprator + month + dateSeprator + day
        return timeFormat
    }
}
/**
 * 导出方法
 * @param {} fileName
 * @param {} blogObj 
 */
function exportBlogObject(fileName, blogObj, ext = 'xlsx') {
    // 参考[https://blog.csdn.net/weixin_36934930/article/details/80707615]
    let url = window.URL.createObjectURL(blogObj);
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    // 取当前时间
    let curDate = new Date()
    let curTimeFormat = formatDateWithSeperator(curDate, '-')

    link.setAttribute('download', `${fileName}-${curTimeFormat}.${ext}`);
    document.body.appendChild(link);
    link.click();
}

function getBizActionList(bizActionListKey) {
    let actionRet = [];
    try {
        if (bizActionListKey) {
            const ret = localStorage.getItem(bizActionListKey);
            if (ret) {
                actionRet = JSON.parse(ret);
            }
        }
    } catch (e) {
        console.log('getBizActionList e=>', e);
    } finally {
        return actionRet;
    }
}

function getPermission(pID, bizActionListKey) {
    let hasPerm = false;
    let permActions = getBizActionList(bizActionListKey);
    for (let key in permActions) {
        if (permActions.hasOwnProperty(key)) {
            let permissions = permActions[key];
            for (let i = 0, len = permissions.length; i < len; i++) {
                if (permissions[i] === pID) {
                    hasPerm = true;
                    break;
                }
            }
        }
    }
    return hasPerm;
}

let env = process ? process.env : null;
const baseYiiUrl = env &&env.baseYiiUrl ? env.baseYiiUrl : (env.baseUrl ? env.baseUrl : '');

export default {
    formatDateWithSeperator,
    exportBlogObject,
    baseYiiUrl,
    getPermission,
    getBizActionList,
}